import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface InsertTableData {
  rows: number;
  cols: number;
}

@Component({
  selector: 'calsoft-insert-table-dialog',
  templateUrl: './insert-table-dialog.component.html',
  styleUrls: ['./insert-table-dialog.component.scss']
})
export class InsertTableDialogComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  rows: number;
  cols: number;

  constructor(@Optional() public dialogRef: MatDialogRef<InsertTableDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: InsertTableData, private router: Router) {
    this.rows = data && data.rows ? data.rows : 2;
    this.cols = data && data.cols ? data.cols : 2;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  cancel() {
    this.dialogRef.close();
  }

  ok() {
    // sanitize to minimum 1
    const r = Math.max(1, Math.floor(this.rows));
    const c = Math.max(1, Math.floor(this.cols));
    this.dialogRef.close({ rows: r, cols: c });
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
